// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"271b75ac","112":"2c12ee8f","214":"2af10280","651":"123d2459","864":"15a7b154","916":"f86f4830","932":"3177d184"}[chunkId] + ".css";
};